export default __webpack_public_path__ + "216d477d2052fcd4a07a155051103068.png";